export default "__VITE_ASSET__2kUFKf1j__"